import React from 'react';
import Link from 'gatsby-link';
import {css} from 'glamor';

const container = css({
  maxWidth: '960px',
  margin: '0 auto',
  minHeight: '700px',
  padding: '20px 10px'
});

const image = css({
  width: '450px',
  float: 'left',
  marginRight: '20px',
  '@media(max-width: 600px)': {
    width: '140px',
  }
});

const text = css({
  '@media(max-width: 600px)': {
    fontSize: '14px',
    lineHeight: '18px'
  }
})

const title = css({
  '@media(max-width: 600px)': {
    fontSize: '20px'
  }
})

const About = ({data}) => {
  const page = _.get(data, 'allContentfulPage.edges[0].node');
  return (
    <div {...container}>
      <img {...image} src={page.heroImage.responsiveSizes.src} srcSet={page.heroImage.responsiveSizes.srcSet}/>
      <p {...text} dangerouslySetInnerHTML={{__html: page.description.childMarkdownRemark.html}}/>
    </div>
  );
}

export default About

export const query = graphql`
  query ContactQuery {
    allContentfulPage(filter:{slug: {eq: "contact"}}) {
      edges {
        node {
          title,
          slug,
          description {
            childMarkdownRemark {
              html
            }
          },
          heroImage {
            responsiveSizes {
              aspectRatio
              src
              srcSet
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.js